import React from 'react'
import styled from 'styled-components'

// styles
import colors from '../../../styles/colors'

const BoxShadow = ({
  className,
  children,
  paddingVertical,
  paddingHorizontal,
  maxWidth,
}) => {
  return (
    <Container
      className={className}
      paddingVertical={paddingVertical}
      paddingHorizontal={paddingHorizontal}
      maxWidth={maxWidth}
    >
      {children}
    </Container>
  )
}
export default BoxShadow

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + 'px' : '768px')};
  min-width: 320px;
  border-radius: 15px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};
  padding: ${(props) =>
    props.paddingVertical || props.paddingHorizontal
      ? `${props.paddingVertical ?? 0}px ${props.paddingHorizontal ?? 0}px`
      : '22px'};
`
